module.exports = __webpack_public_path__ + "img/feelme-logo.364a73e9.png";